import { Grain } from "@/components/Grain";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { Catalog } from "@/components/Catalog";
import { Manifesto } from "@/components/Manifesto";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <main className="bg-background text-foreground" data-testid="home-page">
      <Grain />
      <Navbar />
      <Hero />
      <EditorialMarquee />
      <Catalog />
      <Manifesto />
      <Contact />
      <Footer />
    </main>
  );
}
